export default __webpack_public_path__ + "static/loyall-featured-image-rebranding-story-light-fb8b94748ef1df316a8e69ce854ed68f.jpg";